export type ICDLServiceImplFactory = ReturnType<typeof CDLServiceImplFactory>;

export const CDLServiceImplFactory = ({
  cdlRepository,
}: {
  cdlRepository: ICDLRepository;
}) => {
  const getPatientGraphData: ICDLService["getPatientGraphData"] = async (
    payload
  ) => {
    const response = await cdlRepository.getPatientDataFromCDL({
      patient_id: payload.patient_id,
      date_from: payload.dateRange.from,
      date_to: payload.dateRange.to,
    });
    return response;
  };

  const getPatientDailyRRData: ICDLService["getPatientDailyRRData"] = async (
    payload
  ) => {
    const response = await cdlRepository.getPatientDailyRRData({
      patient_id: payload.patient_id,
      date_from: payload.dateRange.from,
      date_to: payload.dateRange.to,
    });
    return response;
  };

  const getBedExitMotionData: ICDLService["getBedExitMotionData"] = async (
    payload
  ) => {
    const response = await cdlRepository.getBedExitMotionData({
      patient_id: payload.patient_id,
      date_from: payload.dateRange.from,
      date_to: payload.dateRange.to,
    });
    return response;
  };

  const getHeartRateData: ICDLService["getHeartRateData"] = async (payload) => {
    const response = await cdlRepository.getHeartRateData({
      patient_id: payload.patient_id,
      date_from: payload.dateRange.from,
      date_to: payload.dateRange.to,
    });
    return response;
  };

  const getIlluminationData: ICDLService["getIlluminationData"] = async (
    payload
  ) => {
    const response = await cdlRepository.getIlluminationData({
      patient_id: payload.patient_id,
      date_from: payload.date_from,
      date_to: payload.date_to,
    });
    return response;
  };

  const getLiveMinutelyVitals: ICDLService["getLiveMinutelyVitals"] = async (
    payload
  ) => {
    const response = await cdlRepository.getLiveMinutelyVitals({
      patient_id: payload.patient_id,
      date_from: payload.dateRange.from,
      date_to: payload.dateRange.to,
    });
    return response;
  };

  return {
    getPatientGraphData,
    getBedExitMotionData,
    getHeartRateData,
    getPatientDailyRRData,
    getIlluminationData,
    getLiveMinutelyVitals,
  };
};
